export default __webpack_public_path__ + "static/Inter-Regular-9dbae3472dff246b54bf9d21cc5b6ef2.woff2";